<ng-template #eventOptions let-ev="ev" let-idx="idx" let-mobile="mobile" let-card="card">
  <ng-container *ngIf="{ id: idx + '-' + (mobile ? 'mobile' : 'desktop'), admin: !!accounts[ev.accountId]?.is_admin, manager: !!accounts[ev.accountId]?.is_manager, open: !ev.closed && !!ev.can_access, owner: userService.uid === ev.event_owner?.uid, potentialOwners: potentialOwnersByEventIds[ev.eventId] || [] } as vars">
    <div [id]="vars.id" class="actions-dots" [ngClass]="{ card: card }" (click)="$event.stopPropagation(); $event.preventDefault();" [matMenuTriggerFor]="eventOptions"><icon matIcon='more_vert'></icon></div>
    <mat-menu #eventOptions="matMenu" xPosition="before">
      <div class="owner-changer" (click)="$event.stopPropagation()" 
        *ngIf="!ev.is_readonly && (vars.manager || vars.owner || vars.admin) && vars.potentialOwners.length"
      > Change Event Owner 
        <potential-owners
          [currentOwner]="ev.event_owner"
          [potentialOwners]="vars.potentialOwners" 
          (changeOwner)="changeOwner(ev, $event)"
        ></potential-owners>
      </div>
      <button mat-menu-item (click)="grantWorkforcePrivileges(ev)" *ngIf="(vars.manager || accounts[ev.accountId]?.is_leader) && !ev.can_access">Join workforce</button>
      <button mat-menu-item (click)="editEventTitle(ev)" *ngIf="vars.open && (vars.manager || vars.owner)">Edit event name</button>
      <button mat-menu-item (click)="eventService.openingEvent($event, ev)">View</button>
      <button mat-menu-item (click)="changeEventStatus(ev)" *ngIf="vars.open && (vars.manager || vars.owner)">Change event status</button>
      <button mat-menu-item (click)="addLabel(vars.id, ev)" *ngIf="vars.open && vars.manager">Add event label</button>
      <button mat-menu-item (click)="duplicateEvent(ev)" *ngIf="vars.manager">Duplicate event</button>
      <button mat-menu-item (click)="changeEventAccount(ev)" *ngIf="canChangeEventAccount && vars.manager">Change event account</button>
      <button mat-menu-item (click)="closeEvent(ev)" *ngIf="vars.open && vars.manager">Close event</button>
      <button mat-menu-item (click)="deleteEvent(ev, vars.id)" *ngIf="vars.manager && ev.can_access">Delete event</button>
      <button mat-menu-item (click)="leaveWorkforce(ev, vars.id)" *ngIf="ev?.can_access && (!ev.event_owner || (
        userService.email !== ev.event_owner.email && !vars.owner))">Leave workforce</button>
    </mat-menu>
  </ng-container>
</ng-template>

<ng-container *ngIf="dashboardPageType === 'card'">
  <loader-pane-fragment  [trace]="traceNames.viewHome" [stopOptions]="{attributes:[{name:'Layout', value:dashboardPageType}, {name:'NumberOfEvents', value:visibleEvents.length}]}"></loader-pane-fragment>
  <!-- <button mat-button class="extra large" (click)="startNewEvent()">+ Create an event</button> -->
  <div class="event smooth" [ngClass]="{closed: ev.closed, cancelled: ev.closeReason}" 
    *ngFor="let ev of visibleEvents; index as idx; trackBy: trackByEvent" (click)="eventService.openingEvent($event, ev, !!suspendedMap[ev.accountId])">
    <div class="left_cell" *ngIf="{ daysUntil: eventViewService.daysUntil(ev) } as vars">
        <div class="date" [ngClass]="{tba: !ev.dates || ev.dates?.length==0}">
            {{ev.dates?.length ? (str2day(ev.dates[0]) | date:'EEE dd MMM y') : 'Date TBA'}}
        </div>
        <div class="until" *ngIf="vars.daysUntil.indexOf('day')>0">{{ vars.daysUntil + ' until event'}}</div>
        <div class="suspended" *ngIf="!!suspendedMap[ev.accountId]">Account suspended</div>
        <div class="close close_btn" *ngIf="!ev.closed && vars.daysUntil=='past' && accounts[ev.accountId]?.is_manager" (click)="closeEvent(ev)"> Close event &rsaquo;</div>
        <div class="close" *ngIf="ev.closed" >Event closed</div>
    </div>
    <div class="right_cell">
      <div class="title">
        <span class="readonly" *ngIf="!ev.closed &&  ev.is_readonly">
          <icon matIcon='visibility'></icon> 
        </span>
        <b [ngClass]="{cancelled: ev.closeReason}">{{ev.title}} </b>
        <!--{{ev.closed ? (ev.closeReason ? ' - Cancelled' : ' - Complete') : ''}}-->
        <event-status [eventId]="ev.eventId" [outsideEvent]="true" [dotOnly]="true"></event-status>
      </div>
      <div class="dates" *ngIf="ev.dates_string">{{ev.dates_string.join(' ')}}</div>
      <div class="labels" *ngIf="ev.labels && eventLabels[ev.eventId]">
          <label-tier [labels]="ev.labels" [template]="eventLabels[ev.eventId]"></label-tier>
      </div>
    </div>
    <ng-container [ngTemplateOutlet]="eventOptions" [ngTemplateOutletContext]="{idx: idx, ev: ev, isList: false, mobile: false, card: true }" ></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="dashboardPageType=='list'">
  <loader-pane-fragment [trace]="traceNames.viewHome" [stopOptions]="{attributes:[{name:'Layout', value:dashboardPageType}, {name:'NumberOfEvents', value:visibleEvents.length}]}"></loader-pane-fragment>
  <div class="gridTable">

      <div class="title header">
          <div class="cell" (click)="updateOrder('title')">
              <span>Name</span>
              <icon class="order_arrow" [ngClass]="{show: event_order.key == 'title'}" [matIcon]="(event_order.rev?'arrow_upward':'arrow_downward')"></icon>
          </div>
      </div>
      <div class="title row pointer" *ngFor="let ev of visibleEvents; index as idx; trackBy: trackByEvent" (click)="eventService.openingEvent($event, ev)"
              [ngClass]="{ oddrows: idx % 2 == 0, closed: ev.closed }">
          <div class="cell">
              <div class="event_name" [ngClass]="{cancelled: ev.closeReason}">
                  <div class="readonly" *ngIf="!ev.closed && ev.is_readonly"><icon matIcon='visibility'></icon></div>
                  <div class="ev-title">{{ev.title}}</div>
                  <event-status [outsideEvent]="true" [eventId]="ev.eventId" [dotOnly]="true"></event-status>
              </div>
              <div class="labels" *ngIf="ev.labels && eventLabels[ev.eventId]">
                  <label-tier [labels]="ev.labels" [template]="eventLabels[ev.eventId]"></label-tier>
              </div>
          </div>
        </div>

      <div class="date header">
          <div class="cell" (click)="updateOrder('first_date')">
              <icon matIcon='date_range'></icon>
              <span>Date</span>
              <icon class="order_arrow" [ngClass]="{show: event_order.key == 'first_date'}" [matIcon]="(event_order.rev ? 'arrow_upward' : 'arrow_downward')"></icon>
          </div>
      </div>
      <div class="date row pointer"
        *ngFor="let ev of visibleEvents; index as idx; trackBy: trackByEvent" (click)="eventService.openingEvent($event, ev)"
        [ngClass]="{ oddrows: idx % 2 == 0, tba: !ev.dates || ev.dates?.length==0, closed: ev.closed, cancelled: ev.closeReason }">
        <div class="cell">
            <span class="desktop">{{ev.dates?.length ? (str2day(ev.dates[0]) | date:'EEEE dd MMMM y') : 'Date TBA'}}</span>
            <span class="mobile">{{ev.dates?.length ? (str2day(ev.dates[0]) | date:'EEE dd MMM y') : 'Date TBA'}}</span>
            <br class="mobile" />
            <span *ngIf="ev.dates?.length && ev.dates.length > 1" class="additional_days_note">&nbsp;(+ {{ev.dates.length - 1}} date{{ev.dates.length > 2 ? 's' : ''}})</span>
        </div>
      </div>

      <div class="desktop misc header"></div>
      <div class="desktop misc row pointer" [ngClass]="{ oddrows: idx % 2 == 0, closed: ev.closed }"
        *ngFor="let ev of visibleEvents; index as idx; trackBy: trackByEvent" (click)="eventService.openingEvent($event, ev)">
        <div class="cell" *ngIf="{ daysUntil: eventViewService.daysUntil(ev) } as vars">
            <div class="until" *ngIf="vars.daysUntil.indexOf('day')>0">{{ vars.daysUntil + ' until event'}}</div>
            <div class="close" *ngIf="!ev.closed && vars.daysUntil=='past' && accounts[ev.accountId]?.is_manager" (click)="closeEvent(ev)"> Close event &rsaquo;</div>
            <!--<div class="close" *ngIf="ev.closed" >Event closed {{ev.closeReason ? ' - Cancelled' : ' - Complete'}}</div>-->
        </div>
      </div>
      <div class="desktop actions header"></div>
      <div class="desktop actions row pointer" (click)="eventService.openingEvent($event, ev)"
        *ngFor="let ev of visibleEvents; index as idx; trackBy: trackByEvent" [ngClass]="{ oddrows: idx % 2 == 0, closed: ev.closed }">
        <div class="cell">
          <ng-container [ngTemplateOutlet]="eventOptions" [ngTemplateOutletContext]="{idx: idx, ev: ev, isList: true, mobile: false }"></ng-container>
        </div>
      </div>
  </div>
</ng-container>

<div class="bottom-padder" *ngIf="dashboardPageType !== 'calendar' && pages?.length > 1">
  <paginator 
    [pageIndex]="pageIndex" 
    [itemsPerPage]="itemsPerPage" 
    [pages]="pages"
    [entityName]="'Event'"
    (setPageIndex)="setPageIndex($event)"
    (updateItemsPerPage)="updateItemsPerPage($event)"
  ></paginator>
</div>



